document.addEventListener("DOMContentLoaded", function () {
    const back = document.getElementById("back-to-top");
    const cookies = document.querySelector(".cookies-consent");
    if (cookies.style.display !== 'none' && back) {
        back.style.display = 'none';

        cookies.querySelector("button").addEventListener("click", (cookie) => {
            back.style.display = 'block';
        })
    }
    if (back) {
        window.addEventListener('scroll', () => {
            const isScrolled = window.scrollY > 0;
            if (isScrolled) {
                back.classList.add("active");
            } else {
                back.classList.remove("active");
            }

            back.onclick = () => {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }
        })
    }
})